module.exports = __webpack_public_path__ + "static/media/Bot2.eff74627.jpg";